import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { CustomerDashboardColumnStatusAPI } from '@business/api/customer_dashboard_column_status';
import { CustomerDashboardColumnStatusResponse, UpsertColumnStatusRequest } from '@business/entities/tm/CustomerDashboardColumnStatusResponse';
import { handleMessage, requestMessage } from '@business/messages';

export class CustomerDashboardColumnStatusBloc extends BaseBloc {
  private readonly repo = new Repository<CustomerDashboardColumnStatusResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.repo.items$;

  readonly selectItem = this.repo.selectItem;

  onReset() {
    this.repo.reset();
  }

  upsertStatus = (data: UpsertColumnStatusRequest) => {
    return CustomerDashboardColumnStatusAPI.upsertColumnStatus(data).pipe(
      this.repo.ops.upsertOne(item => ({ item })),
      handleMessage({ type: requestMessage('upsert_customer_dashboard_column_status') }),
    );
  };

  deleteStatus = (id: string) => {
    return CustomerDashboardColumnStatusAPI.deleteColumnStatus(id).pipe(
      this.repo.ops.removeOne(() => id),
      handleMessage({ type: requestMessage('delete_customer_dashboard_column_status') }),
    );
  };
}
